<template>
    <div :class="showBoxClass">
        <div :class="$style['loader']">
            <svg :class="$style['circular']" viewBox="25 25 50 50">
                <circle :class="$style['path']" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
            </svg>
            <p :class="$style['loading-text']" v-if="loadingText != ''">{{loadingText}}</p>
        </div>
    </div>
</template>



<script>
    export default {
        data() {
            return {
                loadingText: ''
            }
        },
        computed: {
            showBoxClass() {
                return `${this.$style['showbox']} ${this.$style['section']}`;
                //if(this.type == 'section')
                //    return `${this.$style['showbox']} ${this.$style['section']}`;
                //else
                //    return this.$style['showbox'];
            }
        }
    }
</script>

<style lang="scss" module>
$green: #cc254f;
$blue: #cc254f;
$red: #cc254f;
$yellow: #cc254f;

// scaling... any units
$width: 50px;

// demo-specific
.showbox {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 5%;

  &.section {
    position: fixed;
    padding: 0;
    height: 100%;
    background: rgba(255,255,255,0.6);
    z-index: 10003;

    .loader {
        top: 50%;
        margin-top: -28px;
        width: 100%;
        text-align: center;
        position: absolute;
    }
  }
}
// end demo-specific

.loading-text {
    margin: 0;
    font-weight: 700;
}

.loader {
  position: relative;
  text-align: center;
}

.circular {
  animation: rotate 2s linear infinite;
  width: $width;
  height: $width;
}

.path {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
  stroke-linecap: round;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}

@keyframes color {
  100%,
  0% {
    stroke: $red;
  }
  40% {
    stroke: $blue;
  }
  66% {
    stroke: $green;
  }
  80%,
  90% {
    stroke: $yellow;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/VueStyleGuide/Components/Spinner/SpinnerService.vue